export default __webpack_public_path__ + "static/media/zoom.28e6244c.svg";